import { show } from 'redux-modal'
import { STORE_CHANGE_MODAL } from 'constant'

export const showChangeStoreModal = (showOneButtonModal) => (dispatch) => {
  dispatch(show(STORE_CHANGE_MODAL, { showOneButtonModal }))
}
